module.exports = {
    BASE_URL: '/SupportSrv/SupportSrv.svc/Support',
    BOTS: '/api/bot/public'
};
